export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_DATA = 'SET_USER_DATA'
